interface IconProps {
	disabled?: boolean;
}

export const ForwardIcon = ({ disabled }: IconProps) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.75784 8L5.22223 4.11094L6.2322 3L10.7778 8L6.2322 13L5.22223 11.8891L8.75784 8Z"
				fill={disabled ? '#959595' : '#FFFFFF'}
			/>
		</svg>
	);
};
